module.exports = __webpack_public_path__ + "img/pr-1.7a8ef4cf.png";